import { render, staticRenderFns } from "./DeviceSTPFacts.vue?vue&type=template&id=7ec9df2c&scoped=true&"
import script from "./DeviceSTPFacts.vue?vue&type=script&lang=ts&"
export * from "./DeviceSTPFacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec9df2c",
  null
  
)

export default component.exports